import { jsx as _jsx } from "react/jsx-runtime";
import loadable from '@loadable/component';
import Loading from './Loading';
export function AsyncLoader(func, customLoadingComponent) {
    const Component = customLoadingComponent;
    return loadable(func, { fallback: Component ? Component : _jsx(Loading, {}) });
}
